import { render, staticRenderFns } from "./viewpreschooldetails.vue?vue&type=template&id=a6f99b3c&scoped=true"
import script from "./viewpreschooldetails.vue?vue&type=script&lang=js"
export * from "./viewpreschooldetails.vue?vue&type=script&lang=js"
import style0 from "./viewpreschooldetails.vue?vue&type=style&index=0&id=a6f99b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f99b3c",
  null
  
)

export default component.exports